
import { ChangeDetectorRef,
         Component,
         OnInit } from '@angular/core'

import { FormBuilder,
         FormGroup,
         Validators } from '@angular/forms'

import { ActivatedRoute, Router } from '@angular/router'

import { SocialAuthService,
         SocialAuthServiceConfig,
         GoogleLoginProvider,
         SocialUser } from '@abacritt/angularx-social-login'

import { AppConstants, AuthService, CookieService, RouterService, User} from '../../_core'
import { firstValueFrom } from 'rxjs'
import { HttpErrorResponse } from '@angular/common/http'
import { MatSnackBar } from '@angular/material/snack-bar'

@Component({
  selector: 'ss-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  // providers: [
  //   SocialAuthService,
  // ]
})

export class LoginComponent implements OnInit {

  auth$: any
  socialAuth$: any
  loginForm: FormGroup | undefined
  socialUser!: SocialUser
  isLoggedIn: boolean = false
  isRedirecting: boolean = false

  returnPath$: any
  returnPath: string

  returnPathAdminDefault = '/admin'
  returnPathNotAdminDefault = '/'
  returnPathNotLoggedInDefault = '/'

  queryParam$: any

  form!: FormGroup
  isLoading = false
  submitted = false

  emailRegex: string = AppConstants.EMAIL_REGEX
  user$: any
  currentUser: User
  isAdmin: boolean

  cookie$: any


  constructor(
    private authService: AuthService,
    private cdr: ChangeDetectorRef,
    private cookieService: CookieService,
    private matSnackbar: MatSnackBar,
    private formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private routerService: RouterService,
    private socialAuthService: SocialAuthService,
  ) { }

  ngOnInit() {
    console.log('CHECK login')
    this.cookieService.populateCookieConsentFromCookie()

    // init form object
    this.form = this.formBuilder.group({
      email: ['', [Validators.required, Validators.pattern(this.emailRegex)]],
      password: ['', Validators.required]
    });

    this.queryParam$ = this.queryParamStream()
    this.user$ = this.userStream()
    this.socialAuth$ = this.socialAuthStream()

    // let cookieConsent = this.cookieService.getCookieConsent()
    // console.log('COOKIE?', cookieConsent)
    
    this.cookie$ = this.cookieStream()
  }

  ngOnDestroy() {
    if (this.auth$) this.auth$.unsubscribe()
    if (this.socialAuth$) this.socialAuth$.unsubscribe()
  }

  queryParamStream() {
    return this.route.queryParams.subscribe(qp => {
      let redir = qp['redir']
      if (!redir) return

      this.returnPath = decodeURI(redir)
      if (this.returnPath == '') this.returnPath = null // this.defaultReturnUrl
      // console.log('redir', this.returnPath, redir)
    })
  }

    cookieStream() {
    return this.cookieService.cookieConsent.subscribe( res => {
      // this.cookieConsent = res
      // console.log('TODO: cookieConsent', res) // , res['necessary'])
      if (!res || !res['necessary']) {
        this.routerService.updateOutlet('p', 'cookies')
      } 
        // console.log('TODO: cookie consent popup')
      this.detectChanges()
    })
  }

  socialAuthStream() {
    return this.socialAuthService.authState.subscribe((socialUser: SocialUser) => {
      this.socialUser = socialUser
      this.isLoggedIn = (this.socialUser != null)
      // console.log('socialUser:', this.socialUser)
      return firstValueFrom(this.authService.getSocialUserDetails(this.socialUser))
      .then(deets => {
        // loginSocial updates currentUser from socialUser:
        return firstValueFrom(this.authService.loginSocial(this.socialUser)).then((user:User) => {
          // this.checkAdmin(user)
        })
        // this.authService.updateToken(this.socialUser.idToken)
      }).catch(err => {
        console.warn('ERR: socialAuthStream', err)
      })
    })
  }

  userStream() {
    // console.log('CHECK login userStream')

    return this.authService.currentUser.subscribe(user => {
      // console.log('USER', user)
      this.currentUser = user
      this.isLoggedIn = (this.currentUser != null)

      this.checkAdmin(this.currentUser)

      if (this.currentUser) this.navigateToReturnUrl()
      this.detectChanges()
    })
  }

  get f() { return this.form.controls }

  onSubmit() {
    this.submitted = true;

    if (this.form.invalid) return

    this.isLoading = true
    window.setTimeout(this.submitNow.bind(this), 500)
  }

  submitNow() {
    let loginParams = {
      email: this.f.email.value,
      password: this.f.password.value
    }

    firstValueFrom(this.authService.login(loginParams)).then(res => {
      return this.handleLogin(res)
    }).catch((err: HttpErrorResponse) => {
      // console.log('ERR: login', err)
      switch (err.status) {
        case 401: {
          this.f['password'].setErrors({'incorrect': true});
        }
        default: console.log('ERR: unknown', err)
      }
      this.isLoading = false
    })
  }

  handleLogin(res: any): Promise<any> {
    // this.authService.loginFromTokenResponse(res)
    return this.authService.updateTokenFromTokenResponse(res).then(res => {
      console.log('handleLogin', res)
      // this.updateHelptext({ confirmation: res })
      window.setTimeout(this.navigateToReturnUrl.bind(this), 2000);
    })
  }
  navigateToReturnUrl(params={}) {
    if (params['delay']) window.setTimeout(this.navigateToReturnUrlNow.bind(this), params['delay'])
    return this.navigateToReturnUrlNow()
  }

  navigateToReturnUrlNow() {
    if (this.returnPath) return this.router.navigateByUrl(this.returnPath)
    this.detectChanges()
    // return this.router.navigate([this.defaultReturn])
    let returnPath = this.isAdmin ? this.returnPathAdminDefault : this.returnPathNotAdminDefault
    return this.router.navigateByUrl(returnPath) //, { skipLocationChange: true })
  }

  handleClose(e: any) {
    console.log('handleClose')
  }

  handleSelectRegister() {
    // console.log('TODO: register form')
    return this.matSnackbar.open('Contact us for access', 'close');
  }

  checkAdmin(user: User) {
    this.isAdmin = user && user.isRole('admin')
    // console.log('>>> checkAdmin:', user, this.isAdmin)
  }

  detectChanges() {
    if (!this.cdr['destroyed']) this.cdr.detectChanges()
  }
}